import { faRefresh } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import VoxelIconButton from '../../../components/voxel/Buttons/VoxelIconButton';
import VoxelText from '../../../components/voxel/Text/VoxelText';

export interface ColorSwatchListProps {
  title: string;
  reset: () => void;
}

export const ColorSwatchList: React.FC<ColorSwatchListProps> = ({ children, title, reset }) => {
  return (
    <div className="flex flex-col gap-2">
      <div className="flex flex-row gap-2 items-center">
        <VoxelText variant="bread-semibold" paddingBot>
          {title}
        </VoxelText>
        <VoxelIconButton
          color="white"
          onClick={reset}
          tooltip="Reset colors to default theme"
          icon={<FontAwesomeIcon icon={faRefresh} title="Reset" />}
        />
      </div>
      <div className="flex flex-row items-center gap-0">{children}</div>
    </div>
  );
};

export default ColorSwatchList;
